import { render } from "./ThePriceCompetitor.vue?vue&type=template&id=3cd807d4"
import script from "./ThePriceCompetitor.vue?vue&type=script&lang=js"
export * from "./ThePriceCompetitor.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__